










































































































































































































































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Modal from '@/components/Modal'
import SuperBar from '@modules/ui/Offer/actions/SuperBar'
import SubmitBar from '@modules/ui/Offer/actions/SubmitBar'
import AcceptanceBar from '@modules/ui/Offer/actions/AcceptanceBar'
import Back from '@modules/ui/buttons/Back'
import Timeline from '@modules/ui/components/Timeline'

import OfferHeader from '@modules/ui/Offer/OfferHeader'
import OfferDetails from '@modules/ui/Offer/steps/OfferDetails'
import BrandProvides from '@modules/ui/Offer/steps/BrandProvides'
import UniversityProvides from '@modules/ui/Offer/steps/UniversityProvides'
import Activations from '@modules/ui/Offer/steps/Activations'
import EmptyActivation from '@modules/ui/Offer/steps/EmptyActivation'

import OrganizerOfferAlertBar from '@hostComponents/Offer/OfferAlertBar'
import SponsorOfferAlertBar from '@sponsorComponents/Offer/OfferAlertBar'

import RequestButton from '@/components/RequestButton'

import TransferInstanceTriggerModal from '@triggers/Offer/TransferInstanceTriggerModal'
import SwapListingTriggerModal from '@triggers/Offer/SwapListingTriggerModal'
import SetOfferShippingAreaTriggerModal from '@triggers/Offer/SetOfferShippingAreaTriggerModal'
import SetOfferBankingContactTriggerModal from '@triggers/Offer/SetOfferBankingContactTriggerModal'
import VoidOfferTriggerModal from '@triggers/Offer/VoidOfferTriggerModal'
import ExtendOfferExpirationTriggerModal from '@triggers/Offer/ExtendOfferExpirationTriggerModal'

isDev = process.env.NODE_ENV is 'development'

settings =
  name: 'OfferShow'
  components: {
    'organizer-offer-alert-bar' : OrganizerOfferAlertBar,
    'sponsor-offer-alert-bar' : SponsorOfferAlertBar,
    Modal,
    SuperContainerView,
    SubmitBar,
    SuperBar,
    AcceptanceBar,
    Back,
    OfferHeader,
    OfferDetails,
    BrandProvides,
    UniversityProvides,
    Activations,
    EmptyActivation,
    RequestButton,
    TransferInstanceTriggerModal,
    SwapListingTriggerModal,
    SetOfferShippingAreaTriggerModal,
    SetOfferBankingContactTriggerModal,
    VoidOfferTriggerModal,
    ExtendOfferExpirationTriggerModal,
  }

  resources:
    offer:
      resourceName: "offer"
      slug: "offers/:offerId"
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'
      fetch: false
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/:vendorListingId'
      fetch: false

  vue:
    props: ['offerId']
    computed:
      devMode: -> isDev

      bill: -> @offer.bill || {}

      purchaseOrder: -> @ctxPurchaseOrder @offer

      audienceListingId: -> @ctxAudienceListing(@offer).id
      vendorListingId: -> @ctxVendorListing(@offer).id
      listing: -> @audience_listing || @vendor_listing

      isProductSampling: ->
        return @offer.activation_snapshot_space_names[0] == 'Product Sampling'
      activations: -> (act for name, act of @offer?.activation_snapshots)
      activation: -> @activations?[0]
      offerProgress: ->
        acceptedCount = 0
        offerAcceptance = true
        acceptedCount++ if @offer.accepted
        for key, agreement of @offer.offer_acceptance_agreement
          offerAcceptance = offerAcceptance and agreement.accepted
          acceptedCount++ if agreement.accepted
        return { count: acceptedCount, accepted: offerAcceptance, percentComplete: Math.round(acceptedCount * 100 / 4) }
      offerStatusBorderClass: ->
        switch @offer.state
          when 'pending', 'submitted' then 'border-draft'
          when 'accepted' then 'border-success'
          when 'denied' then 'border-red'
          else 'border-divider'
      offerStatusTagClass: ->
        switch @offer.state
          when 'pending', 'submitted' then 'bg-draft'
          when 'accepted' then 'bg-success'
          when 'denied' then 'bg-red'
          else 'bg-recess'
      alertBg: ->
        return 'bg-success' if @offer.accepted
        return 'bg-red' if @offer.denied || @offer.canceled || @offer.ignored
        return 'bg-draft' if @offer.in_revision
        switch @offerProgress.percentComplete
          when 0 then 'bg-recess'
          when 25, 50 then 'bg-draft'
          when 75 then 'bg-recess'
      alertStatus: ->
        return 'This offer has been accepted.' if @offer.accepted
        return 'This offer has been denied.' if @offer.denied
        return 'This offer has been canelled.' if @offer.canceled
        return 'This offer was ignored.' if @offer.ignored
        return 'This offer is currently being revised.' if @offer.in_revision
        switch @offerProgress.percentComplete
          when 0 then "Congratulations! You've received an offer. Please agree to the terms and accept the offer, if it is a good fit."
          when 25, 50 then 'Please agree to all of the terms in order to accept the offer.'
          when 75 then 'Thanks for agreeing to the terms. You can now accept the offer.'
      dayExpiresAt: -> dayjs(@offer.expires_at).add(1, 'day')
      isExpired: ->  not @dayExpiresAt.isAfter(dayjs())

      # hasAdditionalOrganizerTOS: -> @listing.partner_additional_terms?.length
      additionalOrganizerTOS: -> @listing?.special_terms

      payoutStatus: ->
        @offer.payout_status
      payoutStatusConfig: ->
        configs =
          pending_approval:
            label: 'Pending Approval'
            badgeClass: 'bg-draft text-white'
            textClass: 'text-draft'
            at: @offer.payout_arc.pending_approval_at
            by: @offer.payout_arc.pending_approval_by
          approved:
            label: 'Payout Approved'
            badgeClass: 'bg-recess text-white'
            textClass: 'text-recess'
            at: @offer.payout_arc.approved_at
            by: @offer.payout_arc.approved_by
          sent:
            label: 'Payout Sent'
            badgeClass: 'bg-green text-white'
            textClass: 'text-green'
            at: @offer.payout_arc.sent_at
            by: @offer.payout_arc.sent_by
          canceled:
            label: 'Payout Canceled'
            badgeClass: 'bg-red text-white'
            textClass: 'text-red'
            at: @offer.payout_arc.canceled_at
            by: @offer.payout_arc.canceled_by
        configs[@payoutStatus]

      canApprovePayout: ->
        @payoutStatus is 'pending_approval'

      canCancelPayout: ->
        !@isBillApprovalStartedOrCompleted && @payoutStatus isnt 'canceled'

      canUndoPayout: ->
        !@isBillApprovalStartedOrCompleted && @payoutStatus isnt 'pending_approval'

      isBillApprovalStartedOrCompleted: ->
        !!@bill.is_approval_started_or_completed

      dealIds: ->
        @compact(@purchaseOrder.deal_ids || []).join(', ')

      billTimeline: ->
        return [{ content: 'No bill created yet', icon: 'far fa-times' }] unless @bill.bill_id

        approved = {
          content: 'Approved',
          icon: 'far fa-check-double',
          complete: @bill.is_approved,
        }

        denied = {
          complete: @bill.is_denied,
          content: 'Denied',
          icon: 'far fa-times',
        }

        scheduled = {
          content: 'Scheduled',
          icon: 'far fa-clock',
          complete: @bill.is_scheduled || @bill.is_sent || @bill.is_paid,
        }

        sent = {
          content: 'Sent',
          icon: 'far fa-paper-plane',
          complete: @bill.is_sent || @bill.is_paid,
        }

        paid = {
          content: 'Paid',
          icon: 'far fa-dollar-sign',
          complete: @bill.is_paid,
        }

        items = []

        if @bill.is_denied
          items.push denied
        else
          items.push approved

        items.push scheduled
        items.push sent
        items.push paid
        items

    data: ->
      dataCollectionKeys: ["name", "email", "phone","grad_year", "dob", "mailing_address"]
      dataCollectionLabels: {name: "Name", email: 'Email', phone: 'Phone', grad_year: 'Graduation Year', dob: 'Date of Birth', mailing_address: 'Mailing Address'}
      openPanel: null
      showMoreOfferActions: false
      actionModal:
        show: false
        action: null
        button:
          label: ''
          handler: null
      acceptanceModal:
        show: false
      denialModal:
        show: false
        reasons: []
        action: null
        button:
          label: ''
          handler: null
      voidModal:
        show: false
        reason: null
        voided_by: null

    methods:
      onLoadItemCompleted: (resourceKey) ->
        if resourceKey is 'offer'
          if @audienceListingId
            @fetch 'audience_listing'
          else if @vendorListingId
            @fetch 'vendor_listing'

      promptToAccept: ->
        unless @offerProgress.percentComplete == 75
          @showAlert 'Please read and accept each section of the offer!', 'Accept All Offer Sections' 
          return
        if @isExpired
          @showAlert 'This offer is no longer available.', 'Offer Expired' 
          return 
        @actionModal =
          show: true
          action: 'accept'
          button: { label: 'Accept Offer', handler: @acceptOffer }
      acceptOffer: ->
        if not @offerProgress.accepted
          return @displayAlert 'Please agree to all of the terms in order to accept this offer.'

        payload = offer_acceptance_agreement: @offer.offer_acceptance_agreement
        @triggerResource 'offer', 'accept', payload if @offer.pending
        @denialModal?.reasons = []
      onOfferAccept: ->
        @promptToSetShippingArea() if @isProductSampling
        # @promptToSetBankingContact()

      selectDenialReason: (reason) ->
        if !@denialModal.reasons?.includes reason
          @denialModal.reasons.push reason
        else
          @denialModal.reasons = (r for r in @denialModal.reasons when r isnt reason)
      denialReasonIsSelected: (reason) ->
        @denialModal.reasons?.includes reason

      revertOffer: ->
        @ifDebug =>
          @triggerResource 'offer', 'revert_choice' if @offer.revertable
          @denialModal?.reasons = []

      promptToDeny: ->
        @denialModal =
          show: true
          action: 'deny'
          reasons: @denialModal.reasons
          button: { label: 'Deny Offer', handler: @denyOffer }
      denyOffer: ->
        denial_reasons = @denialModal.reasons
        denial_reasons.push @denialModal.otherReason if @denialModal.otherReason
        @triggerResource 'offer', 'deny', {denial_reasons} if @offer.pending
      promptToSubmit: ->
        @actionModal =
          show: true
          action: 'submit'
          button: { label: 'Submit Offer', handler: @submitOffer }
      submitOffer: ->
        @triggerResource 'offer', 'submit' if @offer.submittable # +++ alert message if not submittable
      promptToRevise: ->
        @actionModal =
          show: true
          action: 'revise'
          button: { label: 'Revise Offer', handler: @reviseOffer }
      reviseOffer: ->
        @triggerResource 'offer', 'revise' if @offer.denied
      promptToRevoke: ->
        @actionModal =
          show: true
          action: 'revoke'
          button: { label: 'Revoke Offer', handler: @revokeOffer }
      revokeOffer: ->
        @triggerResource 'offer', 'revoke'
      promptToResubmit: ->
        @actionModal =
          show: true
          action: 'resubmit'
          button: { label: 'Resubmit Offer', handler: @resubmitOffer }
      resubmitOffer: ->
        @triggerResource 'offer', 'resubmit' if @offer.in_revision
      promptToCancel: ->
        @actionModal =
          show: true
          action: 'cancel'
          button: { label: 'Cancel Offer', handler: @cancelOffer }
      cancelOffer: ->
        @triggerResource 'offer', 'cancel'
      promptToDelete: ->
        @actionModal =
          show: true
          action: 'delete'
          button: { label: 'Delete Offer', handler: @deleteOffer }
      deleteOffer: ->
        @triggerResource 'offer', 'delete', { offer_id: @offer.id }
      promptToUnbindEvent: ->
        @actionModal =
          show: true
          action: 'remove event from'
          button: { label: 'Remove Event', handler: @unbindEvent }
      unbindEvent: ->
        @triggerResource 'offer', 'unbind_event'
      promptToUndo: ->
        @actionModal =
          show: true
          action: 'undo'
          button: { label: 'Undo Offer', handler: @undoOffer }
      undoOffer: ->
        @triggerResource 'offer', 'undo'

      onOfferDelete: () ->
        @$router.push({ name: 'OfferListPage' })
      
      onOfferUnbindEvent: () ->
        @fetchAllResources()

      onResourceTriggerCompleted: (resourceKey, event) ->
        @actionModal.show = false
        @denialModal.show = false

      toggleAcceptance: (key) -> 
        if @isExpired
          @showAlert 'This offer is no longer available.', 'Offer Expired' 
          return 
        if !@offer.pending
          return
        @offer.offer_acceptance_agreement[key].accepted = !@offer.offer_acceptance_agreement[key].accepted
        payload = offer_acceptance_agreement: @offer.offer_acceptance_agreement
        @triggerResource 'offer', 'sign_agreement', payload 
        @acceptanceModal.show = true if @offerProgress.percentComplete == 75
        if @openPanel < 2
          @openPanel++ 
        else 
          @openPanel = null
        # @showAlert "You can now accept this offer!" if @offerProgress.count is 3
      
      onOfferAddMemberNote: -> @fetch('offer')
      onOfferAddSuperNote: -> @fetch('offer')
      
      promptToCsvExport: ->
        @actionModal =
            show: true
            action: 'Export Offer'
            button: { label: 'Send to email', handler: @csvExport }
      csvExport: ->
        @triggerResource 'offer', 'csv_export', { format: 'single_offer_advancing' }

      hiCheckOther: ->
        if @denialModal.otherReason?.length
          @denialModal.otherReason = ''
          return

        @denialModal = { ...@denialModal, otherReason: 'Other: ' }
        @$refs.otherReason.focus()

      hiTransferInstanceTrigger: ->
        payloadOptions = {}
        modalOptions = { currentEventSetId: @listing.event_set_id }
        @$refs.transferInstanceTrigger.fire(payloadOptions, modalOptions)
      onOfferTransferInstance: ->
        @$refs.transferInstanceTrigger.close()

      promptToSwapListing: ->
        payloadOptions = {}
        modalOptions = { @offer }
        @$refs.swapListingTrigger.fire payloadOptions, modalOptions
      onOfferSwapListing: ->
        @$refs.swapListingTrigger.close()

      promptToExtend: ->
        payloadOptions = {}
        modalOptions = {}
        @$refs.extendOfferExpirationTrigger.fire payloadOptions, modalOptions
      onOfferExtendExpiration: ->
        @$refs.extendOfferExpirationTrigger.close()

      promptToSetShippingArea: ->
        payloadOptions = {}
        modalOptions = { @offer }
        @$refs.setOfferShippingAreaTrigger.fire payloadOptions, modalOptions
      onOfferSetShippingArea: ->
        @$refs.setOfferShippingAreaTrigger.close()
      
      promptToSetBankingContact: ->
        payloadOptions = {}
        modalOptions = { @offer }
        @$refs.setOfferBankingContactTrigger.fire payloadOptions, modalOptions
      onOfferSetBankingContact: ->
        @$refs.setOfferBankingContactTrigger.close()

      promptToVoid: ->
        payloadOptions = {}
        modalOptions = { @offer }
        @$refs.voidOfferTrigger.fire payloadOptions, modalOptions
      onOfferVoid: ->
        @$refs.voidOfferTrigger.close()

      promptToLock: ->
        @actionModal =
          show: true
          action: 'lock'
          button: { label: 'Lock Offer', handler: @lockOffer }
      lockOffer: ->
        @triggerResource 'offer', 'lock'
      onOfferLock: ->
        @fetch 'offer'

      promptToUnlock: ->
        @actionModal =
          show: true
          action: 'unlock'
          button: { label: 'Unlock Offer', handler: @unlockOffer }
      unlockOffer: ->
        @triggerResource 'offer', 'unlock'
      onOfferUnlock: ->
        @fetch 'offer'

      hiCopyToClipboard: (event, value) ->
        @copyToClipboard event, value
        @showFlash { 'Message:': 'Copied to clipboard!' }

      hiMarkAsPayoutApproved: ->
        @triggerResource 'offer', 'mark_as_payout_approved'
      onOfferMarkAsPayoutApproved: ->
        @fetch 'offer'

      hiMarkAsPayoutSent: ->
        @triggerResource 'offer', 'mark_as_payout_sent'
      onOfferMarkAsPayoutSent: ->
        @fetch 'offer'

      hiMarkAsPayoutCanceled: ->
        @triggerResource 'offer', 'mark_as_payout_canceled'
      onOfferMarkAsPayoutCanceled: ->
        @fetch 'offer'

      hiUndoPayout: ->
        @triggerResource 'offer', 'undo_payout_status'
      onOfferUndoPayoutStatus: ->
        @fetch 'offer'

export default VueOptions.vue settings
